interface StatusTabsProps {
  statuses: string[];
  selected: string;
  onSelect: (status: string) => void;
  counts: { [key: string]: number };
}

const StatusTabs: React.FC<StatusTabsProps> = ({
  statuses,
  selected,
  onSelect,
  counts
}) => (
  <div className="flex space-x-2">
    {statuses.map((status) => {
      const normalized = status.toLowerCase();
      const isActive = normalized === selected;

      return (
        <div
          key={status}
          onClick={() => onSelect(status)}
          className={`flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer ${
            isActive
              ? "bg-[#FEF0E8] text-orange-500"
              : "bg-[#F4F4F4] text-[#344054]"
          }`}
        >
          <span
            className={`font-bold ${
              isActive ? "text-orange-500" : "text-[#344054]"
            }`}
          >
            {status}
          </span>
          <span className="text-[#344054] bg-[#F9FAFB] border border-[#EAECF0] px-2 py-0.5 text-sm rounded-full">
            {counts[normalized] ?? 0}
          </span>
        </div>
      );
    })}
  </div>
);

export default StatusTabs;
